import {ReactElement} from "react"
import {Link} from "react-router-dom"
import {useTranslate} from "@refinedev/core"
import {List} from "@refinedev/antd"
import {Col, Row} from "antd"
import {getActivities} from "../../services/ServiceActivity"
import {getClients} from "../../services/ServiceClient"
import {getAuthentications} from "../../services/ServiceAuthentication"
import {getTypes} from "../../services/ServiceType"
import ActivityCard from "../../components/cards/ActivityCard"

export default function ActivityList(): ReactElement | null {
    const translate = useTranslate()
    const {activities} = getActivities()
    const {clients} = getClients()
    const {authentications} = getAuthentications()
    const {types} = getTypes()
    // @ts-ignore
    const headerButtons = ({defaultButtons}) => <><Link to={'../lti'}>LTI (debug)</Link>{defaultButtons}</>
    return <List title={translate('activity.meta.list')} headerButtons={headerButtons}>
        <Row gutter={[16, 16]}>
            {activities?.map((activity) =>
                <Col key={activity.id} span={8}>
                    <ActivityCard activity={activity} clients={clients} authentications={authentications} types={types}/>
                </Col>
            )}
            {activities?.length === 0 && <Row>{translate("activity.meta.no")}</Row>}
        </Row>
    </List>
}